import { render, staticRenderFns } from "./ImagesGrid.vue?vue&type=template&id=524188f7&scoped=true&"
import script from "./ImagesGrid.vue?vue&type=script&lang=ts&"
export * from "./ImagesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesGrid.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImagesGrid.vue?vue&type=style&index=1&id=524188f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524188f7",
  null
  
)

export default component.exports